import dayjs from "dayjs";
import { CDN_URL, DU_DOAN_COLORS } from "./constants";

export function getTopRankCardStyle(rank) {
  const r = Number(rank);
  const base = {
    backgroundColor: DU_DOAN_COLORS.leaderboardItemBg,
    borderColor: DU_DOAN_COLORS.cardBorder,
  };
  if (r === 1) {
    return {
      borderColor: "#F5C518",
      background: "linear-gradient(160deg, #FFFEF8 0%, #FFF8E1 100%)",
      boxShadow: "0 2px 12px rgba(245, 166, 35, 0.2)",
    };
  }
  if (r === 2) {
    return {
      borderColor: "#9CB8E0",
      background: "linear-gradient(160deg, #FAFCFF 0%, #EEF4FF 100%)",
      boxShadow: "0 2px 10px rgba(10, 104, 255, 0.12)",
    };
  }
  if (r === 3) {
    return {
      borderColor: "#E8A060",
      background: "linear-gradient(160deg, #FFFCFA 0%, #FFF0E6 100%)",
      boxShadow: "0 2px 10px rgba(253, 149, 2, 0.14)",
    };
  }
  return base;
}

export function getCurrentPeriod() {
  return dayjs().format("YYYY-MM");
}

export function getRecentPeriods(count = 3) {
  const periods = [];
  for (let i = 0; i < count; i += 1) {
    periods.push(dayjs().subtract(i, "month").format("YYYY-MM"));
  }
  return periods;
}

export function formatPeriodTabLabel(period) {
  if (!period) return "";
  const month = Number(period.split("-")[1]);
  return `Tháng ${month}`;
}

export function formatWinRate(value) {
  if (value == null || Number.isNaN(Number(value))) return "—";
  const num = Number(value);
  return Number.isInteger(num) ? `${num}%` : `${num.toFixed(1)}%`;
}

export function formatPoint(value) {
  return (value ?? 0).toLocaleString();
}

export function isAccountVerified(user) {
  if (!user) return false;
  if (user.verified === true || user.isVerified === true || user.is_verified === true) {
    return true;
  }
  if (user.verified === 1 || user.isVerified === 1 || user.is_verified === 1) {
    return true;
  }
  return false;
}

export function getAvatarUrl(avatar) {
  if (!avatar || typeof avatar !== "string") return null;
  if (avatar.startsWith("http://") || avatar.startsWith("https://")) return avatar;
  const cleanPath = avatar.startsWith("/") ? avatar : `/${avatar}`;
  return `${CDN_URL}${cleanPath}`;
}
